import { useSelector } from "react-redux";
import DynamicLoader from "../Form/FormFields/DynamicLoader";
import Heading from "../ui/Heading";
import DonutCharts from "../chart/DonutCharts";
import NoteComponent from "../ui/table/Notes";
import Tab from "../tab/Tab";
import StatusGrid from "./StatusGrid";
import Accordion from "../ui/Accordion";

function Count({ ...props }) {
  const propsData = props?.chartListData;
  const notes = propsData?.note;
  const noteData = propsData?.remarks;

  const selectorData = useSelector((state: any) => state?.dynamicData);

  // Check if chart_value exists in props (pre-loaded data)
  const hasChartValue =
    propsData?.chart_value && propsData.chart_value.length > 0;

  // Use chart_value from props if available, otherwise use Redux selector data
  const chartData = hasChartValue
    ? propsData.chart_value
    : selectorData[propsData?.id];

  // Only show loading when fetching from API (no chart_value in props)
  const isLoading =
    !hasChartValue && selectorData.loaders[`report/chart/${propsData?.id}`];

  const hasTab = props?.chartListData?.has_tab;

  return (
    <>
      <div className={`grid gap-2 ${props.width && props.width}`}>
        {/* Column 1 */}
        <div className="">
          <div className="bg-white p-4 rounded-lg bg-contain bg-no-repeat bg-center  ">
            <div className="flex justify-between items-center mb-5">
              <div className="flex items-center">
                <Heading title={propsData?.title} />
                {notes && (
                  <NoteComponent
                    notes={noteData}
                    modalTitle={propsData?.title}
                  />
                )}
              </div>
              {hasTab && (
                <Tab
                  tabData={propsData?.chart_tabs}
                  chartId={propsData?.id}
                  props={props}
                />
              )}
            </div>

            {isLoading ? (
              <DynamicLoader loading={isLoading} />
            ) : (
              <div className="mt-5 mb-8">
                <DonutCharts resData={chartData} propsData={propsData} />
                <div className="mt-5">
                  <StatusGrid data={chartData} propsData={propsData} />
                </div>
              </div>
            )}
            {!hasChartValue && (
              <Accordion
                title="AI Insights"
                componentID={propsData?.id}
                chartData={propsData}
                chartValue={selectorData[propsData?.id]}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Count;
